import fs from 'fs';
import crypto from 'crypto';
import Promise from 'bluebird';
import {times} from 'lodash';

Promise.promisifyAll(fs);

class Chunker {
  constructor(filepath, {chunkSize} = {chunkSize: 64 * 1e4}) {  // 640ko
    this.filepath = filepath;
    this.chunkSize = chunkSize;
    // this.initChunks();
  }

  init(skipHashmap = false) {
    return fs.openAsync(this.filepath, 'r')
      .then((fd) => {
        this.fd = fd;
        return fs.fstatAsync(this.fd);
      })
      .then((stat) => {
        this.size = stat.size
        this.realChunkCount = this.size / this.chunkSize;
        this.chunkCount = Math.ceil(this.size / this.chunkSize);

        // Init hashmap
        if (!skipHashmap) return this.initHashMap();
        return Promise.resolve();
      });
  }

  initHashMap() {
    return Promise.map(times(this.chunkCount), (index) => {
      return this.getChunk(index)
        .then((buf) => {
          const hash = crypto.createHash('sha1');
          const data = hash.update(buf);
          return data.digest('hex');
        });
    }, {concurrency: 20})
    .tap((hashes) => {
      this.hashes = hashes;
      // console.log(JSON.stringify(this.hashes, null, 2));
    });
  }

  getChunkSize() {
    return this.chunkSize;
  }

  getChunkCount() {
    return this.chunkCount;
  }

  getChunk(index) {
    const buf = Buffer.alloc(index < this.realChunkCount - 1 ? this.chunkSize : this.size % this.chunkSize);
    return fs.readAsync(this.fd, buf, 0, buf.length, index * this.chunkSize)
      .then(() => {
        return buf;
      });
  }

  getHashMap() {
    return this.hashes;
  }

  close() {
    return fs.closeAsync(this.fd);
  }
}

export default Chunker;
